module.exports = __webpack_public_path__ + "static/media/fast-sportLeft.4f1fada9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/fast-sport/fast-sportLeft.svg
// module id = 2457
// module chunks = 7